/**
 * @generated SignedSource<<da5705b88ff278f1702c4e5c103ef6b5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
export type FinishUploadFileInput = {
  key: string;
};
export type FileUploadFinishMutation$variables = {
  input: FinishUploadFileInput;
};
export type FileUploadFinishMutation$data = {
  readonly finishUploadFile: {
    readonly downloadUrl: Url;
  };
};
export type FileUploadFinishMutation = {
  response: FileUploadFinishMutation$data;
  variables: FileUploadFinishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FinishUploadFile",
    "kind": "LinkedField",
    "name": "finishUploadFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FileUploadFinishMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "FileUploadFinishMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "cd38caa3cea6ad786b1391b1849e4e9e",
    "id": null,
    "metadata": {},
    "name": "FileUploadFinishMutation",
    "operationKind": "mutation",
    "text": "mutation FileUploadFinishMutation(\n  $input: FinishUploadFileInput!\n) {\n  finishUploadFile(input: $input) {\n    downloadUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef4da35d01aeddf489b18556958d9688";

export default node;
